import { apiService } from './api';

export interface EarnProvider {
  providerId: number;
  providerName: string;
  providerCode: string;
  isActive: boolean;
}

export interface EarnTransaction {
  transactionId: string;
  providerName: string;
  offerTitle: string | null;
  amountEarned: number;
  status: string;
  completedDate: string | null;
  creditedDate: string | null;
  reversedDate: string | null;
  reversalReason: string | null;
  createdDate: string;
}

export interface EarnHistoryResponse {
  transactions: EarnTransaction[];
  totalCount: number;
}

export interface EarnSummary {
  lifetimeEarnings: number;
  thisMonthEarnings: number;
  pendingAmount: number;
  reversedAmount: number;
  totalCompletedOffers: number;
  totalReversedOffers: number;
}

class EarnCreditsService {
  async getProviders(): Promise<EarnProvider[]> {
    return apiService.get<EarnProvider[]>('/api/earn/providers');
  }

  async getWallUrl(providerCode: string): Promise<{ url: string }> {
    return apiService.get<{ url: string }>(`/api/earn/wall-url/${providerCode}`);
  }

  async getHistory(limit: number = 50, offset: number = 0): Promise<EarnHistoryResponse> {
    return apiService.get<EarnHistoryResponse>(`/api/earn/history?limit=${limit}&offset=${offset}`);
  }

  async getSummary(): Promise<EarnSummary> {
    return apiService.get<EarnSummary>('/api/earn/summary');
  }
}

export const earnCreditsService = new EarnCreditsService();
export default earnCreditsService;
